export const VERSION = {
  /**
   * Version of `@microsoft/api-extractor` to pin for the docs-sync
   * public-API drift detection runner. Used by the `ApiExtractor`
   * component (wired into every `TypeScriptProject`) and the shared
   * helper at `.claude/procedures/extract-api.sh`. See docs-sync
   * epic child issue #513.
   */
  API_EXTRACTOR_VERSION: "7.58.7",

  /**
   * Version of Astro to pin for AstroProject scaffolding.
   */
  ASTRO_VERSION: "7.3.2",

  /**
   * CDK CLI for workflows and command line operations.
   *
   * CLI and lib are versioned separately, so this is the CLI version.
   */
  AWS_CDK_CLI_VERSION: "2.1141.0",

  /**
   * CDK Version to use for construct projects.
   *
   * CLI and lib are versioned separately, so this is the lib version.
   */
  AWS_CDK_LIB_VERSION: "2.269.0",

  /**
   * Version of the AWS Constructs library to use.
   */
  AWS_CONSTRUCTS_VERSION: "10.8.1",

  /**
   * Version of Node.js to use in CI workflows at github actions.
   */
  NODE_WORKFLOWS: "24",

  /**
   * Version of `pnpm/action-setup` to use in GitHub workflows.
   * Tracks the version projen currently emits (see node_modules/projen/lib/javascript/node-project.js).
   */
  PNPM_ACTION_SETUP_VERSION: "v6.0.5",

  /**
   * Version of PNPM to use in workflows at github actions.
   */
  PNPM_VERSION: "12.4.1",

  /**
   * Version of Projen to use.
   */
  PROJEN_VERSION: "0.103.23",

  /**
   * Version of `actions/setup-node` to use in GitHub workflows.
   * Tracks the version projen currently emits (see node_modules/projen/lib/github/workflows.js).
   */
  SETUP_NODE_ACTION_VERSION: "v6",

  /**
   * Version of sharp to pin for StarlightProject (required peer for
   * Starlight's image optimization pipeline).
   */
  SHARP_VERSION: "0.35.4",

  /**
   * Version of `@astrojs/starlight` to pin for StarlightProject scaffolding.
   */
  STARLIGHT_VERSION: "0.42.0",

  /**
   * What version of the turborepo library should we use?
   */
  TURBO_VERSION: "2.10.12",

  /**
   * Version of `@types/node` to use across all packages (pnpm catalog).
   */
  TYPES_NODE_VERSION: "26.5.1",

  /**
   * What version of Vitest to use when testRunner is 'vitest'.
   *
   * Also pins `@vitest/coverage-v8`, whose `vitest` peer dependency is an
   * exact match rather than a range — the two always move together. Both
   * packages are seeded into the monorepo's pnpm catalog from this constant,
   * so `Vitest` renders them as `catalog:` wherever that catalog exists.
   */
  VITEST_VERSION: "5.0.0",
} as const;
